/**
 * A random (version 4) UUID that works on plain HTTP too.
 *
 * `crypto.randomUUID()` only exists in a secure context — HTTPS or localhost.
 * Opened over a LAN address like http://192.168.1.102:5173 it is undefined,
 * and calling it threw before the login request was ever sent: the page
 * loaded, the button did nothing, and nothing reached the server (D54).
 * `crypto.getRandomValues()` is available everywhere, so fall back to it.
 */
export function uuid(): string {
  const c = globalThis.crypto;
  if (typeof c?.randomUUID === "function") return c.randomUUID();
  const b = c.getRandomValues(new Uint8Array(16));
  b[6] = (b[6]! & 0x0f) | 0x40; // version 4
  b[8] = (b[8]! & 0x3f) | 0x80; // RFC 4122 variant
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
